var locale = {
  locale: 'nl-be',
  months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
  weekdaysLong: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
  weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
  firstDayOfWeek: 1,
  nextMonth: 'Volgende maand',
  previousMonth: 'Vorige maand'
};
export default locale;